// @flow

import _ from 'lodash';
import React, { type Node } from 'react';
import bemify, { toModifiers } from 'bemify-js';

import Icon from 'app/common/components/Icon';
import PopoverArrow from 'app/common/components/PopoverArrow';
import 'app/common/components/Popover.scss';

import type { KindType } from 'app/common/types';

const bem = bemify('popover');

type SimplePopoverProps = {
  children: Node,
  className?: string,
  direction?: 'up' | 'down' | 'right' | 'left',
  hasArrow: boolean,
  kind?: KindType,
  onClose?: () => void,
};

export const SimplePopover = (props: SimplePopoverProps) => {
  const className = bem(
    toModifiers('simple', props.direction, props.kind),
    props.className
  );
  const closeButton = !props.onClose ? null : (
    <Icon
      className={bem('__close-button')}
      onClick={props.onClose}
      type="delete"
    />
  );
  const arrow = !!props.hasArrow && !!props.direction && (
    <PopoverArrow className={bem('__arrow')} direction={props.direction} />
  );
  return (
    <div className={className}>
      {arrow}
      <div className={bem('__content-container')}>
        <div className={bem('__content')}>{props.children}</div>
        {closeButton}
      </div>
    </div>
  );
};

SimplePopover.defaultProps = {
  hasArrow: true,
};

export default SimplePopover;

type SimplePopoverWrapperProps = {
  children: Node,
  className?: string,
  isHoverable: boolean,
};

export const SimplePopoverWrapper = (props: SimplePopoverWrapperProps) => {
  const className = bemify('popover-wrapper')(
    { '--hoverable': props.isHoverable },
    props.className
  );
  return (
    <div {..._.omit(props, 'isHoverable')} className={className}>
      {props.children}
    </div>
  );
};

SimplePopoverWrapper.defaultProps = {
  isHoverable: false,
};
